import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Clock, AlertTriangle } from 'lucide-react';

/**
 * Modal de aviso de inatividade
 * Exibe um countdown antes do logout automático
 */
const InactivityWarningModal = () => {
  const { 
    showInactivityWarning, 
    inactivityCountdown, 
    keepSessionAlive,
    logout 
  } = useAuth();

  if (!showInactivityWarning) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay escuro */}
      <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
      
      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 animate-fade-in">
        {/* Ícone de alerta */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-amber-600" />
          </div>
        </div>
        
        {/* Título */}
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
          Sessão Inativa
        </h2>
        
        {/* Descrição */}
        <p className="text-gray-600 text-center mb-6">
          Você será desconectado por inatividade em:
        </p>
        
        {/* Countdown */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3 bg-red-50 border-2 border-red-200 rounded-xl px-6 py-4">
            <Clock className="w-8 h-8 text-red-500" />
            <span className="text-4xl font-bold text-red-600 font-mono">
              {inactivityCountdown}
            </span>
            <span className="text-lg text-red-500">segundos</span>
          </div>
        </div>
        
        {/* Botões */}
        <div className="flex gap-4">
          <button
            onClick={logout}
            className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Sair agora
          </button>
          <button
            onClick={keepSessionAlive}
            className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg"
          >
            Continuar conectado
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
